export default __webpack_public_path__ + "static/media/rotate-pause.06cc44df.svg";